var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnRepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#4B4B7C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.986 5.658c-.009.137-.052.269-.13.396-.077.127-.175.191-.294.191h-4.512c-.219.009-.324-.146-.314-.464l1.723-1.721c-.994-.874-2.146-1.311-3.459-1.311-.948 0-1.825.234-2.632.703-.807.469-1.445 1.106-1.914 1.912-.469.806-.704 1.685-.704 2.636 0 .952.235 1.828.704 2.629.469.801 1.107 1.436 1.914 1.905.807.469 1.684.703 2.632.703.802 0 1.556-.171 2.263-.512.443-.214.844-.479 1.203-.796.358-.316.895-.383 1.271-.089.387.302.454.868.1 1.208-.527.505-1.127.92-1.802 1.248-.948.46-1.96.69-3.035.69-.948 0-1.855-.184-2.721-.553-.866-.369-1.611-.865-2.235-1.489-.624-.624-1.121-1.368-1.49-2.233s-.554-1.771-.554-2.718c0-.947.185-1.851.554-2.711.369-.86.866-1.603 1.49-2.226.624-.624 1.369-1.12 2.235-1.489.866-.369 1.773-.553 2.721-.553.884 0 1.729.159 2.536.478.807.319 1.529.765 2.167 1.339l1.832-1.83c.319-.009.474.096.465.314l-.014 4.343z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRepeat);
export default __webpack_public_path__ + "static/media/icn_repeat.d2e5f455.svg";
export { ForwardRef as ReactComponent };